import type { ReportDocumentOptions } from "@digits-graphql/frontend/graphql-bearer"
import { PopUp } from "@digits-shared/components/UI/Elements/PopUp/PopUp"
import { hasFirstElement } from "@digits-shared/helpers/arrayHelper"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"

/*
  STYLES
*/

export const DetailsPopUp = styled(PopUp)`
  display: block;
  font-size: 12px;
  background: ${colors.white};
  margin: 0 0 50px 10px;
  border: none;
  box-shadow: 0 0 34px rgba(0, 0, 0, 0.5);
`

/*
  Functions
*/
/**
 * Determines if report is broken down by class by checking if there are selected departments or locations.
 * @param options - Report document options
 * @returns Boolean indicating if the report is broken down by class
 */
export function hasClassBreakdownSelections(options?: ReportDocumentOptions | null): boolean {
  if (!options?.breakdownByClass) return false
  return (
    hasFirstElement(options.categoryByLocationOptions?.locations) ||
    hasFirstElement(options.categoryByDepartmentOptions?.departments)
  )
}
